import * as React from 'react';
import PropTypes from "prop-types";
import {Col, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import ApplicationSwitch from "../../Application/ApplicationSwitch";
import LabelInfoTooltip from "../../LabelInfoTooltip";
import SupplierDocumentsTypeSelect from "./SupplierDocumentsTypeSelect";
import {useTranslation} from "react-i18next";

function SupplierFalconFields(props) {
  const { t } = useTranslation('supplier_create')

  return (
    <React.Fragment>
      <FormGroup row>
        <Label md={3}>{t('supplier._global.login')}</Label>
        <Col md="9">
          <Input invalid={!!props.errors.login?.errors} placeholder={t('supplier._global.login')} onChange={e => props.onChangeData({login: e.target.value})} value={props.data.login || ''} />
          <FormFeedback>{props.errors.login?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>{t('supplier._global.password')}</Label>
        <Col md="9">
          <Input invalid={!!props.errors.password?.errors} placeholder={t('supplier._global.password')} onChange={e => props.onChangeData({password: e.target.value})} value={props.data.password || ''} />
          <FormFeedback>{props.errors.password?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>
          <span className="mr-1">{t('supplier._global.documents_type')}</span>
          <LabelInfoTooltip msg={t('supplier._global.documents_type_tooltip')} />
        </Label>
        <Col md="9">
          <SupplierDocumentsTypeSelect
            value={props.data.documentsType}
            onChange={documentsType => props.onChangeData({documentsType})}
          />
          <FormFeedback>{props.errors.documentsType?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>{t('supplier._global.downloadCorrection')}</Label>
        <Col md="9">
          <ApplicationSwitch color={'success'} onChange={e => props.onChangeData({ downloadCorrection: e.target.checked ? 1 : 0 })} checked={props.data.downloadCorrection} />
        </Col>
      </FormGroup>
    </React.Fragment>
  );
}

SupplierFalconFields.propTypes = {
  onChangeData: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    login: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
};

export default SupplierFalconFields;
